export enum OrderPaymentStatus {
    Open = 'open',
    Pending = 'pending',
    Authorized = 'authorized',
    Paid = 'paid',
    PartiallyPaid = 'partially_paid',
    Refunded = 'refunded',
    Failed = 'failed',
}